import type { ContentSubmissionRow } from "@/services/contentProgram.service";

/** The words a brand reads for each submission state, and the dot tone. */
export const SUBMISSION_STATUS: Record<string, { label: string; tone: "amber" | "emerald" | "grey" }> = {
  PENDING: { label: "Awaiting review", tone: "amber" },
  CHANGE_REQUESTED: { label: "Changes requested", tone: "amber" },
  APPROVED: { label: "Approved", tone: "emerald" },
  IN_USE: { label: "Running as an ad", tone: "emerald" },
  REJECTED: { label: "Rejected", tone: "grey" },
};

export function submissionStatus(status: string) {
  return SUBMISSION_STATUS[status] ?? { label: status.charAt(0) + status.slice(1).toLowerCase().replace(/_/g, " "), tone: "grey" as const };
}

export function affiliateDisplayName(row: Pick<ContentSubmissionRow, "creatorAffiliate">): string {
  const a = row.creatorAffiliate;
  if (!a) return "Affiliate";
  const name = [a.firstName, a.lastName].filter(Boolean).join(" ").trim();
  return name || a.username || "Affiliate";
}

export function affiliateInitials(row: Pick<ContentSubmissionRow, "creatorAffiliate">): string {
  const name = affiliateDisplayName(row);
  if (name === "Affiliate") return "A";
  const parts = name.split(/\s+/);
  return (parts.length >= 2 ? parts[0][0] + parts[1][0] : name.slice(0, 2)).toUpperCase();
}
